<div [class]="getClassName()">
	<div class="col-12 p-0 p-md-1">
		<div id="carouselCategory" class="carousel">
			<div class="carousel-inner">
				<div class="carousel-item"
					*ngFor="let item of filterBiletKeyWords | paginate: { itemsPerPage: 1, currentPage: pageCurrent }; let i = index"
					[ngClass]="{ active: i === 0 }">

					<app-book-detail-item [bookDetail]="item"></app-book-detail-item>
				</div>
			</div>
			<pagination-controls (pageChange)="pageCurrent = $event; pageChange($event)" previousLabel="" nextLabel="">
			</pagination-controls>
		</div>
	</div>
	<!-- <div class="col-4">
    <app-navbar-youtube></app-navbar-youtube>
  </div> -->
</div>
